module.exports = __webpack_public_path__ + "img/miniLogo.8ece4994.png";